'use strict';

export default class ProtectedController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, $analytics, $location, Config) {
    this.Auth = Auth;
    this.$state = $state;
    this.$analytics = $analytics;
    this.$location = $location;
    this.signUpDeactivated = Config.getModuleConfig(Config.Modules.SignUp).getDeactivated();
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();

    this.preHookHtml = Config.getModuleConfig(Config.Modules.SignUp).getPreHookHtml();
    this.postHookHtml = Config.getModuleConfig(Config.Modules.SignUp).getPostHookHtml();

    this.passwordOnlyLogin = Config.getModuleConfig(Config.Modules.SignUp).getPasswordOnlyLogin();
    this.passwordOnlyEmail = Config.getModuleConfig(Config.Modules.SignUp).getPasswordOnlyEmail();
  }

  login(form) {
    this.submitted = true;

    if (!this.passwordOnlyLogin) {
      this.errors.login = "'Password only' login is not allowed";
      return;
    }

    if(form.$valid) {
      this.Auth.login({
        email: this.passwordOnlyEmail,
        password: this.user.password
      })
        .then(() => {
          if (this.$analytics) {
            this.$analytics.setUsername(this.user.email);
          }

          this.$state.go('home');
        })
        .catch(err => {
          this.errors.login = err.message || err[0].message;

          if (this.errors.login == 'The username or password you entered is incorrect.') {
            this.errors.login = 'The password you entered is incorrect.'
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/protected/protected.controller.js